// @ts-nocheck

import { request } from '../../../../context';
import type { ApiOptions } from '../../../../context';
import type { BaseResponseListAsrTypeResponse } from '../../../../types';

/**
 * list
 *
 * @export
 * @tags asr-filter-config-controller
 * @link [GET] /asr-filter-config/oss/asr/list
 */
export function getAsrFilterConfigOssAsrList(): Promise<BaseResponseListAsrTypeResponse>;
export function getAsrFilterConfigOssAsrList(
    options: ApiOptions<never, never>
): Promise<BaseResponseListAsrTypeResponse>;
export function getAsrFilterConfigOssAsrList(
    options?: ApiOptions<never, never>
): Promise<BaseResponseListAsrTypeResponse> {
    return request<never, never, never>('/asr-filter-config/oss/asr/list', {
        ...options,
        method: 'get',
        __$requestCalleeName: 'getAsrFilterConfigOssAsrList',
    });
}

export const meta = [
    {
        tags: ['asr-filter-config-controller'],
        path: '/asr-filter-config/oss/asr/list',
        method: 'get',
    },
];
